<rask-fieldset-toggle
    [formGroup]="form"
    label="Maskinlag"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-multi-selector
        label="Maskinlag"
        bindValue="key"
        bindLabel="value"
        class="w-100"
        [items]="items"
        formControlName="maskinlag"
        [selected]="control.value"
        [portalToBody]="true"
        [searchFn]="keyValueSearchFn">
    </rask-multi-selector>
</rask-fieldset-toggle>